import { render } from "./Create.vue?vue&type=template&id=3985a7eb&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=3985a7eb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3985a7eb"]])

export default __exports__